import { useEffect, useState } from "react";
import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import FormTypeDropdown from "./components/FormTypeDropdown";
import FormFrequencyDropdown from "./components/FormFrequencyDropdown";

function CreateTemplateModal({
  shown,
  onCancelClicked,
  onSubmitClicked,
  mode = "create",
  initialData = null,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [formType, setFormType] = useState(null);
  const [frequency, setFrequency] = useState("");

  const isEditMode = mode === "edit";

  const reset = () => {
    setName("");
    setDescription("");
    setFormType(null);
    setFrequency("");
  };

  const handleCancel = () => {
    reset();
    onCancelClicked();
  };

  useEffect(() => {
    if (!shown) return;

    if (isEditMode && initialData) {
      setName(initialData.name || "");
      setDescription(initialData.description || "");
      setFormType(initialData.formType ?? null);
      setFrequency(
        initialData.frequency !== null && initialData.frequency !== undefined
          ? String(initialData.frequency)
          : ""
      );
      return;
    }

    reset();
  }, [shown, isEditMode, initialData]);

  const isDisabled =
    !name.trim() ||
    !description.trim() ||
    formType === null ||
    (formType === 0 && frequency === "");

  const handleSubmit = () => {
    if (isDisabled) return;

    onSubmitClicked({
      name: name.trim(),
      description: description.trim(),
      formType,
      frequency: formType === 0 ? Number(frequency) : null,
    });

    reset();
  };

  return (
    shown && (
      <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-30">
        <OutsideClickHandler onOutsideClick={handleCancel}>
          <div className="w-[436px] bg-white rounded-[6px] p-[18px] flex flex-col">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor mb-5">
              {isEditMode ? "EDIT TEMPLATE" : "CREATE TEMPLATE"}
            </p>

            <div className="w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                Template Name <span className="text-red-500">*</span>
              </p>
              <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
                <input
                  value={name}
                  type="text"
                  onChange={(e) => setName(e.target.value)}
                  className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
                  placeholder="Enter template name"
                />
              </div>
            </div>

            <div className="w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-1">
                Description <span className="text-red-500">*</span>
              </p>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="w-full h-[70px] border-solid border-[1px] rounded-[5px] text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium px-2 py-1 resize-none"
                placeholder="Describe the template"
              />
            </div>

            <div className="w-full mb-2">
              <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                Form Type <span className="text-red-500">*</span>
              </p>
              <FormTypeDropdown
                selectedValue={formType}
                onSelect={(val) => {
                  setFormType(val);
                  if (val !== 0) setFrequency("");
                }}
              />
            </div>

            {formType === 0 && (
              <div className="w-full mb-2">
                <p className="text-[12px] font-OpenSansMedium font-[600] text-titleColor mb-2">
                  Frequency <span className="text-red-500">*</span>
                </p>
                <FormFrequencyDropdown
                  selectedValue={frequency}
                  onSelect={setFrequency}
                />
              </div>
            )}

            <div className="w-full mt-2">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={handleCancel}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={() => { if (!isDisabled) handleSubmit(); }}
                  className={`w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center ${isDisabled
                      ? "bg-gray-300 text-white cursor-not-allowed"
                      : "bg-blueColor text-white cursor-pointer"
                    }`}
                >
                  {isEditMode ? "NEXT" : "CREATE"}
                </div>
              </div>
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    )
  );
}

export default CreateTemplateModal;
